jQuery(function ($) {
    const Scripts = {
        varInit() {
            this.header = $("header");
            this.document = $(document);
        },

        init() {
            Scripts.varInit();
        },
    };

    $(document).ready(function () {
        Scripts.init();
    });
});